// Handles OrgID, officeo_clk_id, agency-id, gclid in JS
(function() {
  // --- Helper functions ---
  function setCookie(name, value, days) {
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = '; expires=' + date.toUTCString();
    }
    let secure = location.protocol === 'https:' ? '; secure' : '';
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; samesite=lax' + secure;
  }

  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return decodeURIComponent(parts.pop().split(';').shift());
    return null;
  }

  function getParam(name) {
    const url = new URL(window.location.href);
    return url.searchParams.get(name);
  }

  function uuidv4() {
    // https://stackoverflow.com/a/2117523/508355
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
  }

  // --- OrgID ---
  function ensureOrgID() {
    // generate OrgID on /contact/ page (SEO forms)
    if (!window.location.pathname.startsWith('/contact/')) {
      return localStorage.getItem('OrgID') || getCookie('OrgID') || '';
    }
    
    let orgId = getCookie('OrgID') || localStorage.getItem('OrgID');
    if (!orgId) {
      orgId = uuidv4();
      setCookie('OrgID', orgId, 90);
      localStorage.setItem('OrgID', orgId);
    }
    return orgId;
  }

  // --- officeo_clk_id ---
  function ensureOfficeoClkId() {
    let clkId = getCookie('officeo_clk_id') || localStorage.getItem('officeo_clk_id');
    const utmContent = getParam('utm_content');
    const utmTerm = getParam('utm_term');
    // Only generate if utm_content or utm_term is present in URL (mimic PHP logic)
    if ((utmContent || utmTerm) && !clkId) {
      const timestamp = Math.floor(Date.now() / 1000);
      const trackingString = [utmContent || '', utmTerm || '', timestamp].join('-');
      clkId = btoa(trackingString);
      setCookie('officeo_clk_id', clkId, 90);
      localStorage.setItem('officeo_clk_id', clkId);
    }
    return clkId;
  }

  // --- agency-id ---
  function ensureAgencyId() {
    let agencyId = getCookie('agency-id') || localStorage.getItem('agency-id');
    const agencyIdParam = getParam('agency-id');
    if (agencyIdParam) {
      agencyId = agencyIdParam;
      setCookie('agency-id', agencyId, 90);
      localStorage.setItem('agency-id', agencyId);
    }
    return agencyId;
  }

  // --- gclid ---
  function ensureGclid() {
    let gclid = getCookie('gclid') || localStorage.getItem('gclid');
    const gclidParam = getParam('gclid');
    if (gclidParam) {
      gclid = gclidParam;
      setCookie('gclid', gclid, 90);
      localStorage.setItem('gclid', gclid);
    }
    return gclid;
  }

  // --- source-id ---
  function getSourceId() {
    // SEA form - get source-id from URL (should be 10)
    const sourceIdParam = getParam('source-id');
    if (sourceIdParam) {
      return sourceIdParam;
    }
    
    // SEO form - check if URI starts with "/contact/"
    if (window.location.pathname.startsWith('/contact/')) {
      return "3";
    }
    
    return "";
  }

  // --- Populate hidden fields in forms ---
  function populateFormFields() {
    const orgId = ensureOrgID();
    const clkId = ensureOfficeoClkId();
    const agencyId = ensureAgencyId();
    const gclid = ensureGclid();
    const sourceId = getSourceId();

    // OrgID
    document.querySelectorAll('input[name="OrgID"], input#OrgID, input.OrgID').forEach(function(input) {
      input.value = orgId || '';
    });
    // officeo_clk_id
    document.querySelectorAll('input[name="officeo_clk_id"], input#officeo_clk_id, input.officeo_clk_id').forEach(function(input) {
      input.value = clkId || '';
    });
    // agency-id
    document.querySelectorAll('input[name="agency-id"], input#agency-id, input.agency-id').forEach(function(input) {
      input.value = agencyId || '';
    });
    // gclid
    document.querySelectorAll('input[name="gclid"], input#gclid, input.gclid').forEach(function(input) {
      input.value = gclid || '';
    });
    // sourceId
    document.querySelectorAll('input[name="sourceId"]').forEach(function(input) {
      input.value = sourceId || '';
    });
  }

  document.addEventListener('DOMContentLoaded', populateFormFields);

  // Expose for debugging
  window.officeoIds = {
    ensureOrgID,
    ensureOfficeoClkId,
    ensureAgencyId,
    ensureGclid,
    getSourceId
  };
})(); 